/**
 * @file The one reason shown wherever an analytics surface is disabled
 * because `useAnalyticsConfigured` reads false. Consumers: the Analytics
 * page's not-configured state, the Reports card's New report button and the
 * Preview's Run now button. When it applies, it outranks every other disabled reason.
 */
export const ANALYTICS_NOT_CONFIGURED = 'Analytics is not configured';
